/**
 * Localized text of a failed API call.
 *
 * The backend sends validation errors in three shapes:
 * - `{ detail: { error, message_cs, message_en } }` — AppError.ValidationDetail (e.g. every flight-area
 *   400 — flight_area_unsupported_type, corridor_width_out_of_range, takeoff_point_too_far, ...);
 * - `{ error, message_cs, message_en }` at the root — quota/feature/file-size errors;
 * - `{ detail: "text" }` — plain AppError.Validation (English only), or a FastAPI-style list.
 */
export const getApiErrorMessage = (error, language, fallback) => {
  const data = error?.response?.data;
  const detail = data?.detail;
  const pick = (obj) => (obj && (language === 'cs' ? obj.message_cs : obj.message_en)) || obj?.message_en || obj?.message_cs;

  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    const msg = pick(detail);
    if (msg) return msg;
    if (typeof detail.error === 'string') return detail.error;
  }
  if (data && (data.message_cs || data.message_en)) return pick(data);
  if (typeof detail === 'string' && detail) return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    return detail.map((e) => e?.msg || e?.message || JSON.stringify(e)).join(', ');
  }
  if (typeof data?.error === 'string') return data.error;
  return fallback;
};
